jQuery.keyboard.layouts["ms-Georgian"] = {
    name: "ms-Georgian",
    lang: ["ka"],
    normal: [
        "„ ! ? № § % : . ; , / – = {bksp}",
        "{tab} ღ ჯ უ კ ე ნ გ შ წ ზ ხ ც (",
        "ფ ძ ვ თ ა პ რ ო ლ დ ჟ {enter}",
        "{shift} ( ჭ ჩ ყ ს მ ი ტ ქ ბ / {shift}",
        "{space}"
    ],
    shift: [
        "“ 1 2 3 4 5 6 7 8 9 0 - + {bksp}",
        "{tab} ღ ჯ უ კ ე ნ გ შ წ ზ ხ ც )",
        "ფ ძ ვ თ ა პ რ ო ლ დ ჟ {enter}",
        "{shift} ) ჭ ჩ ყ ს მ ი ტ ქ ბ / {shift}",
        "{space}"
    ],
}

jQuery.keyboard.layouts["ms-Georgian (Ergonomic)"] = {
    name: "ms-Georgian (Ergonomic)",
    lang: ["ka"],
    normal: [
        "„ ! № , ; % : ? . ( ) - “ {bksp}",
        "{tab} ჩ პ უ ძ ჭ ტ თ ნ ვ შ კ ქ /",
        "ხ ი ა ე ო დ მ ს რ ბ გ {enter}",
        "{shift} \\ ჯ ჰ ყ ღ ჟ ზ ც ლ ფ / {shift}",
        "{space}"
    ],
    shift: [
        "' 1 2 3 4 5 6 7 8 9 0 + = {bksp}",
        "{tab} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} §",
        "{empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {enter}",
        "{shift} / {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} / {shift}",
        "{space}"
    ],
    alt: [
        "` ! @ # $ € ^ & * ( ) — = {bksp}",
        "{tab} {empty} {empty} {empty} {empty} {empty} {empty} {empty} ჼ ჳ {empty} [ ] \\",
        "ჴ ჲ ჺ ჱ {empty} {empty} {empty} {empty} {empty} {empty} ჹ {enter}",
        "{shift} {empty} {empty} ჵ ჸ ჷ {empty} {empty} {empty} {empty} ჶ {empty} {shift}",
        "{space}"
    ],
    "alt-shift": [
        "~ {empty} {empty} § {empty} {empty} {empty} {empty} ° « » _ {empty} {bksp}",
        "{tab} {empty} {empty} {empty} {empty} {empty} {empty} {empty} I {empty} {empty} { } |",
        '{empty} {empty} D {empty} {empty} {empty} {empty} {empty} L {empty} " {enter}',
        "{shift} {empty} {empty} X C V {empty} {empty} M < > {empty} {shift}",
        "{space}"
    ]
}

jQuery.keyboard.layouts["ms-Georgian (QWERTY)"] = {
    name: "ms-Georgian (QWERTY)",
    lang: ["ka"],
    normal: [
        "„ 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
        "{tab} ქ წ ე რ ტ ყ უ ი ო პ [ ] ~",
        "{lock} ა ს დ ფ გ ჰ ჯ კ ლ ; ' {enter}",
        "{shift} ზ ხ ც ვ ბ ნ მ , . / {shift}",
        "{space}"
    ],
    shift: [
        "“ ! @ # $ % ^ & * ( ) _ + {bksp}",
        "{tab} {empty} ჭ {empty} ღ თ {empty} {empty} {empty} {empty} {empty} { } |",
        '{lock} {empty} შ {empty} {empty} {empty} {empty} ჟ {empty} ₾ : " {enter}',
        "{shift} ძ {empty} ჩ {empty} {empty} N {empty} < > ? {shift}",
        "{space}"
    ],
}
